export function hasGroup(usersGroups, dottedName) {
  const requiredGroupAsArray = Array.isArray(dottedName) ? dottedName : dottedName.split('.');
  for (const userGroup of usersGroups) {
    // This means that if you're a member of a SUBGROUP,
    // you will match the role.
    if (requiredGroupAsArray.every((n, i) => (n === userGroup[i]))) {
      return true;
    }
  }
  return false;
}

export function hasAnyGroup(usersGroups, ...anyOf) {
  return !!anyOf.find(g => hasGroup(usersGroups, g));
}
